import { render } from "./Sgame.vue?vue&type=template&id=b6dd4a46&scoped=true&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./Sgame.vue?vue&type=script&lang=ts"
export * from "./Sgame.vue?vue&type=script&lang=ts"

import "./Sgame.vue?vue&type=style&index=0&id=b6dd4a46&scoped=true&lang=css"
import "./Sgame.vue?vue&type=style&index=1&id=b6dd4a46&lang=css"
import "./Sgame.vue?vue&type=style&index=2&id=b6dd4a46&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6dd4a46"]])

export default __exports__